/* Dawn 16 variant-change is authoritative. Read-only BCPO compatibility follows
   the installed app's variant-ID select; this component never writes a form. */
if (!customElements.get('sn-egg-rich')) {
  customElements.define('sn-egg-rich', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-egg-config]').textContent);
      this.variants = new Map(this.config.variants.map(variant => [String(variant.id), variant]));
      this.productInfo = [...document.querySelectorAll('product-info[id^="MainProduct-"]')]
        .find(info => info.dataset.productId === this.dataset.productId);
      if (!this.productInfo) return;
      this.onChange = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncFromForm());
      };
      this.productInfo.addEventListener('change', this.onChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const sectionId = this.productInfo.dataset.originalSection || this.productInfo.dataset.section;
          if (data.sectionId !== sectionId || !data.variant) return;
          const variant = this.variants.get(String(data.variant.id));
          if (variant) this.renderVariant(variant);
        });
      }
      this.syncFromForm();
      // BCPO can set .value without a native change event. Read its actual
      // selected Shopify ID (never infer a combination from its swatch UI).
      this.appTimer = setInterval(() => {
        if (!document.hidden && this.productInfo.querySelector('#bcpo-select')) this.syncFromForm();
      }, 250);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.productInfo?.removeEventListener('change', this.onChange);
      cancelAnimationFrame(this.frame);
      clearInterval(this.appTimer);
    }

    syncFromForm() {
      const appSelect = this.productInfo.querySelector('#bcpo-select');
      const variantInput = this.productInfo.querySelector('product-form form [name="id"]');
      const id = appSelect ? appSelect.value : variantInput?.value;
      const variant = this.variants.get(String(id));
      if (variant) this.renderVariant(variant);
    }

    renderVariant(variant) {
      if (String(variant.id) === this.dataset.variantId) return;
      const colour = variant.options[this.config.colourIndex];
      const size = variant.options[this.config.sizeIndex];
      const key = colour?.toLowerCase();
      const recommendation = this.config.sizes[size];
      if (!['red', 'black', 'green'].includes(key) || !recommendation) return;
      const set = (selector, text) => { this.querySelector(selector).textContent = text; };
      set('[data-hero-heading]', `${colour} Egg Marking Ink — ${size}`);
      set('[data-hero-copy]', `Specialist ${key} egg marking ink for clear, repeatable marking using suitable rubber stamps, compatible pads and egg-marking equipment.`);
      set('[data-demo-heading]', `Clear ${key} marking on egg shells`);
      set('[data-demo-copy]', `${colour} Egg Marking Ink produces a clear ${key} impression when used with suitable egg-marking equipment and a compatible stamp and pad.`);
      set('[data-size-heading]', recommendation.heading);
      set('[data-size-copy]', recommendation.copy);
      set('[data-summary-colour]', `${colour} Ink`);
      set('[data-summary-size]', `${size} Bottle`);
      set('[data-summary-use]', recommendation.summary);
      this.querySelectorAll('[data-egg-image]').forEach(image => { image.hidden = image.dataset.eggImage !== key; });
      this.querySelectorAll('[data-size-card]').forEach(card => this.markSelected(card, card.dataset.sizeCard === size, 'Selected size'));
      this.querySelectorAll('[data-colour-card]').forEach(card => this.markSelected(card, card.dataset.colourCard === key, 'Selected colour'));
      this.dataset.colour = key;
      this.dataset.variantId = String(variant.id);
      set('[data-selection-status]', `${colour} ink, ${size} bottle. ${recommendation.summary}.`);
    }

    markSelected(card, selected, label) {
      card.classList.toggle('sn-egg-selected', selected);
      card.querySelector('[data-selected-label]').textContent = selected ? label : '';
    }
  });
}
